import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageWebp from './images/father-carrying-daughter-on-shoulders.webp';
import financialPlanningImageMobileWebp from './images/father-carrying-daughter-on-shoulders-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='investments-financial-planning-2'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={<>Investment advisory services: a key part of a <WidowBlock>financial plan</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            Our focus on long&#45;term investment strategies is designed to help give you the confidence to be disciplined through market fluctuations, knowing that the growth potential and management of your wealth won&#39;t be left to chance.
          </Typography>
          <Typography nextElement='button'>
            Through your Northwestern Mutual financial advisor, you&#39;ll also have access to more financial options, including investments for growth, insurance for protection, and annuities for more flexibility in retirement. Each is designed to reinforce the other so your personalized plan can work its hardest for you.
          </Typography>
          <Link
            id='investment-advisory-services-financial-planning-2-section-financial-planning-link'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            linkUrl='/financial-planning/'>
            Our approach to planning
          </Link>
        </>
      )}
      // image props
      imageAltText='A father carrying his daughter on his shoulders at the beach.'
      imageSrcDefault={financialPlanningImageWebp.toString()}
      imageSrcMobile={financialPlanningImageMobileWebp.toString()}
    />
  );
};
